import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { AppRoutes } from './app.routing';
import { AppComponent } from './app.component';

import { FlexLayoutModule } from '@angular/flex-layout';
import { FullComponent } from './layouts/full/full.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { AppHeaderComponent } from './layouts/full/header/header.component';
import { AppSidebarComponent } from './layouts/full/sidebar/sidebar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DemoMaterialModule } from './demo-material-module';

import { ApiClientService } from './services/util/api.client.service';
import { AuthGuard } from './services/guards/auth.guard';
import { InterceptorService } from './services/util/interceptor.service';
import { PersonService } from './services/person.service';
import { UserService } from './services/user.service';
import { OfficeService } from './services/office.service';

import { SharedModule } from './shared/shared.module';
import { PipesModule } from './services/pipes/pipes.module';
import { FullCalendarModule } from '@fullcalendar/angular';

import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import { SpinnerComponent } from './shared/spinner.component';
import { DetailsAppointmentComponent } from './dialog/details-appointment/details-appointment.component';
import { AbsentAppointmentComponent } from './dialog/absent-appointment/absent-appointment.component';
import { AttendedAppointmentComponent } from './dialog/attended-appointment/attended-appointment.component';
import { CancelAppointmentComponent } from './dialog/cancel-appointment/cancel-appointment.component';
import { CancelReassignAppointmentComponent } from './dialog/cancel-reassign-appointment/cancel-reassign-appointment.component';
import { LoadingService } from './services/util/loading.service';
import { AssignAppointmentComponent } from './dialog/assign-appointment/assign-appointment.component';
import { OverAppointmentComponent } from './dialog/over-appointment/over-appointment.component';
import { DetailsRecordComponent } from './dialog/details-record/details-record.component';
import { AssignAppointmentRecordComponent } from './dialog/assignAppointmentRecord/assignAppointmentRecord.component';
import { CancelReassignRecordComponent } from './dialog/cancel-reassign-record/cancel-reassing-record.component';

@NgModule({
  declarations: [
    AppComponent,
    FullComponent,
    AuthLayoutComponent,
    AppHeaderComponent,
    SpinnerComponent,
    AppSidebarComponent,
    DetailsAppointmentComponent,
    DetailsRecordComponent,
    AbsentAppointmentComponent,
    AssignAppointmentComponent,
    AttendedAppointmentComponent,
    CancelAppointmentComponent,
    CancelReassignAppointmentComponent,
    OverAppointmentComponent,
    AssignAppointmentRecordComponent,
    CancelReassignRecordComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    DemoMaterialModule,
    FormsModule,
    FlexLayoutModule,
    HttpClientModule,
    SharedModule,
    PipesModule,
    FullCalendarModule,
    RouterModule.forRoot(AppRoutes)
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: MAT_DATE_LOCALE, useValue: 'es-AR' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    ApiClientService,
    AuthGuard,
    UserService,
    OfficeService,
    PersonService,
    LoadingService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
